export default "__VITE_ASSET__DkFZiGg9__"